
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"},"content":"<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M20.5 4L25 8.52V26a2 2 0 01-2 2H9a2 2 0 01-2-2V6a2 2 0 012-2h11.5z\" fill=\"#F5455C\"/><path d=\"M20.5 4.002v3.501a1 1 0 001 1H25l-4.5-4.5z\" fill=\"#FFF\" opacity=\".5\"/><path d=\"M13.96 18.917c.352-.694 1.016-2.466 1.335-3.634.447.908.99 1.797 1.883 2.615-1.213.227-2.036.545-3.217 1.019zm1.456-7.775c.926.539.351 1.817.032 2.992-.21-.76-.504-2.447-.032-2.992zm-.089-.318c-.3.039-.62.22-.747.506-.358.818.39 3.226.504 3.628-.727 2.233-3.217 6.646-4.437 6.944-.025-.292.128-1.136 1.737-2.187a2.37 2.37 0 00.223-.272c-1.36.675-3.121 1.758-2.062 2.57a.99.99 0 00.25.123c.81.305 1.946-.695 3.09-2.96 1.257-.421 2.272-.74 3.708-.96 1.57 1.084 2.624 1.305 3.34 1.026.197-.078.51-.331.6-.663-.582.727-1.941.221-3.027-.473 1.002-.11 2.037-.176 2.484-.033.568.182.549.468.542.506.045-.155.109-.408-.013-.61-.478-.791-2.675-.33-3.473-.246-1.257-.772-2.125-2.148-2.477-3.141.326-1.279.677-2.207.422-3.128-.121-.442-.415-.662-.664-.63z\" fill=\"#FFF\"/></g>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
